define.alias("shared/components/shared/user/info", "media/components/shared/user/info");